import { useMemo, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
    TASK_PRIMARY_TYPE,
    TASK_SECONDARY_TYPE,
    TASK_STATUS,
    TASK_SOURCE,
    CUSTOMER_DOC_TYPE,
    TaskSystemLookUp,
    TASK_EXCLUDED_SYSTEM_CODES,
    ARRAY_SERIALIZER,
} from '../constant';
import { getLookupType } from '../apiHelper';
import { requestGetTaskStatusBased } from '../../Store/Tasks/action';

export const useTaskLookups = ({ includeCustomerDocumentType = false } = {}) => {
    const dispatch = useDispatch();
    const lookupData = useSelector(state => state?.lookup?.lookupData);
    const eligibleParentTasks = useSelector(state => state?.tasks?.taskStatusBased || []);

    const taskPrimaryTypeData = useMemo(
        () => getLookupType(lookupData, TASK_PRIMARY_TYPE),
        [lookupData]
    );

    const taskSecondaryTypeData = useMemo(
        () => getLookupType(lookupData, TASK_SECONDARY_TYPE),
        [lookupData]
    );

    const taskStatusData = useMemo(
        () => getLookupType(lookupData, TASK_STATUS),
        [lookupData]
    );

    const taskSourceData = useMemo(
        () => getLookupType(lookupData, TASK_SOURCE),
        [lookupData]
    );

    const docType = useMemo(
        () => (includeCustomerDocumentType ? getLookupType(lookupData, CUSTOMER_DOC_TYPE) : []),
        [lookupData, includeCustomerDocumentType]
    );

    const openTaskStatus = useMemo(
        () => taskStatusData?.find(item => item?.systemLookupCode?.name === TaskSystemLookUp.TASK_STATUS_OPEN),
        [taskStatusData]
    );

    const hasFetchedTaskStatusBasedRef = useRef(false);

    useEffect(() => {
        if (hasFetchedTaskStatusBasedRef.current || !taskStatusData?.length) return;
        hasFetchedTaskStatusBasedRef.current = true;

        const activeStatuses = taskStatusData
            .filter(item => !TASK_EXCLUDED_SYSTEM_CODES.includes(item?.systemLookupCode?.name))
            .map(item => item.name);

        dispatch(requestGetTaskStatusBased({
            params: { status: activeStatuses },
            paramsSerializer: ARRAY_SERIALIZER,
        }));
    }, [dispatch, taskStatusData]);

    return {
        taskPrimaryTypeData,
        taskSecondaryTypeData,
        taskStatusData,
        taskSourceData,
        docType,
        openTaskStatus,
        eligibleParentTasks,
    };
};

export default useTaskLookups;
